// Link do formulário público de credenciamento (autoatendimento).
// Token "stateless": base64 url-safe de { p:partnerId, u:userId, s:sistemas, n:nome }.

export function encodeFichaToken(obj) {
  try {
    const json = JSON.stringify(obj || {});
    return btoa(unescape(encodeURIComponent(json)))
      .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  } catch {
    return "";
  }
}

export function decodeFichaToken(token) {
  try {
    const b = token.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(b))));
  } catch {
    return null;
  }
}

export function fichaFormUrl(token) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/?f=${token}`;
}

// Mensagem padrão de convite
export function convite(nomeEmpresa) {
  const alvo = nomeEmpresa ? ` ${nomeEmpresa}` : "";
  return `Olá!${alvo} Para concluir o credenciamento na rede InstaSolutions, preencha seu nome completo e envie uma foto do seu documento neste link seguro:`;
}

export function whatsappUrl(phone, token, nomeEmpresa) {
  const text = `${convite(nomeEmpresa)}\n${fichaFormUrl(token)}`;
  const d = String(phone || "").replace(/\D/g, "");
  const base = d ? `https://wa.me/${d.length <= 11 ? "55" + d : d}` : "https://wa.me/";
  return `${base}?text=${encodeURIComponent(text)}`;
}

export function emailUrl(token, nomeEmpresa) {
  const subject = "Credenciamento InstaSolutions — envio de documento";
  const body = `${convite(nomeEmpresa)}\n${fichaFormUrl(token)}`;
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

// Mensagem/URLs de correção (reabre a mesma ficha já preenchida)
export function conviteCorrecao(nomeEmpresa) {
  const alvo = nomeEmpresa ? ` de ${nomeEmpresa}` : "";
  return `Olá! Precisamos de um ajuste no seu cadastro${alvo} na rede InstaSolutions. Seus dados já estão preenchidos — é só completar o que falta e reenviar neste link:`;
}
export function correcaoWhatsappUrl(phone, token, nomeEmpresa) {
  const text = `${conviteCorrecao(nomeEmpresa)}\n${fichaFormUrl(token)}`;
  const d = String(phone || "").replace(/\D/g, "");
  const base = d ? `https://wa.me/${d.length <= 11 ? "55" + d : d}` : "https://wa.me/";
  return `${base}?text=${encodeURIComponent(text)}`;
}
// Convite da 2ª etapa: o cadastro já existe, faltam os documentos da empresa.
// Mesmo link de correção (reabre a MESMA ficha), com a flag `d` no token para o
// formulário abrir direto nos documentos e não cobrar o resto da ficha.
//
// O texto é o mesmo para todo mundo de propósito: quem recebe está sendo pedido
// documento pessoal por WhatsApp, e a diferença entre parecer golpe e parecer a
// empresa é dizer QUEM está pedindo, POR QUE, e o que acontece com o arquivo.
// A parte de proteção não é enfeite — é o que a LGPD chama de informar a
// finalidade, e o que faz a pessoa mandar sem ligar para conferir.
export function conviteDocumentos(nomeEmpresa, faltantes = []) {
  const alvo = nomeEmpresa ? ` da ${nomeEmpresa}` : "";
  const n = faltantes.length;
  const itens = n ? faltantes.map((f) => `• ${f}`).join("\n") : "• Contrato social\n• Documento do representante da empresa";
  const quantos = n === 1 ? "1 documento" : `${n || 2} documentos complementares`;
  return [
    `Olá! Aqui é da *InstaSolutions*. 👋`,
    ``,
    `O credenciamento${alvo} já está *ativo na nossa rede* — obrigado por fazer parte.`,
    ``,
    `Para deixar o cadastro completo, faltam ${quantos}:`,
    itens,
    ``,
    `É só abrir o link abaixo e fotografar pelo próprio celular. Não precisa de senha nem de aplicativo, e dá para voltar depois se faltar algum:`,
  ].join("\n");
}

// Aviso de proteção de dados — vai junto do link, e é o mesmo texto que a
// página mostra na hora do envio. Se um lado prometer o que o outro não diz,
// quem está com o documento na mão desconfia (e faz bem).
export const AVISO_LGPD =
  "🔒 Seus documentos estão protegidos: o envio é por conexão segura, os arquivos ficam guardados de forma criptografada em servidor privado e são usados apenas para o seu credenciamento, conforme a LGPD (Lei 13.709/2018). O acesso é restrito à equipe responsável e você pode pedir a exclusão a qualquer momento.";
export function documentosWhatsappUrl(phone, token, nomeEmpresa, faltantes) {
  const text = [
    conviteDocumentos(nomeEmpresa, faltantes),
    fichaFormUrl(token),
    "",
    AVISO_LGPD,
    "",
    "Qualquer dúvida, é só responder por aqui.",
  ].join("\n");
  const d = String(phone || "").replace(/\D/g, "");
  const base = d ? `https://wa.me/${d.length <= 11 ? "55" + d : d}` : "https://wa.me/";
  return `${base}?text=${encodeURIComponent(text)}`;
}

export function correcaoEmailUrl(token, nomeEmpresa) {
  const subject = "Correção de cadastro — InstaSolutions";
  const body = `${conviteCorrecao(nomeEmpresa)}\n${fichaFormUrl(token)}`;
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
